import { toConsumableArray as _toConsumableArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Brandy } from '../Brandy/Brandy.styles.js';
import { Stack as Stack$2 } from './Stack.styles.js';

var Stack = function Stack(_ref) {
  var children = _ref.children,
    _ref$alignMainContent = _ref.alignMainContent,
    alignMainContent = _ref$alignMainContent === void 0 ? 'left' : _ref$alignMainContent,
    _ref$excluded = _ref.excluded,
    excluded = _ref$excluded === void 0 ? [] : _ref$excluded,
    _ref$spaceDisclaimers = _ref.spaceDisclaimers,
    spaceDisclaimers = _ref$spaceDisclaimers === void 0 ? false : _ref$spaceDisclaimers,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 'md' : _ref$spacing;
  return /*#__PURE__*/React.createElement(Stack$2, {
    className: "leshen-stack",
    spacing: spacing,
    excluded: spaceDisclaimers ? excluded : [].concat(_toConsumableArray(excluded), [Brandy]),
    alignMainContent: alignMainContent
  }, children);
};
var Stack$1 = Stack;

export { Stack$1 as default };
//# sourceMappingURL=index.js.map
